import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import * as S from './InfoGrid.style';

const InfoGrid: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const getYear = () => {
    const baseYear = 2026;
    const baseValue = 12;

    return baseValue + (new Date().getFullYear() - baseYear);
  }

  return (
    <S.Section>
      <S.Container>
        <S.Grid>
          <S.GridCard onClick={() => navigate('/uber-mich')}>
            <S.IconContainer>
              <S.Icon src="/assets/images/icon_about_me.png" alt={`Icon: ${t('info.about_title')}`} />
            </S.IconContainer>
            <S.CardTitle>{t('info.about_title')}</S.CardTitle>
            <S.CardDescription>
              {t('info.about_text', { year: getYear() })}
            </S.CardDescription>
          </S.GridCard>

          <S.GridCard onClick={() => navigate('/showroom')}>
            <S.IconContainer>
              <S.Icon src="/assets/images/icon_showroom.png" alt={`Icon: ${t('info.showroom_title')}`} />
            </S.IconContainer>
            <S.CardTitle>{t('info.showroom_title')}</S.CardTitle>
            <S.CardDescription>
              {t('info.showroom_text')}
            </S.CardDescription>
          </S.GridCard>

          <S.GridCard onClick={() => navigate('/verkaufen')}>
            <S.IconContainer>
              <S.Icon src="/assets/images/icon_sell.png" alt={`Icon: ${t('info.sell_title')}`} />
            </S.IconContainer>
            <S.CardTitle>{t('info.sell_title')}</S.CardTitle>
            <S.CardDescription>
              {t('info.sell_text')}
            </S.CardDescription>
          </S.GridCard>

          <S.GridCard onClick={() => navigate('/suchanfrage')}>
            <S.IconContainer>
              <S.Icon src="/assets/images/icon_search.png" alt={`Icon: ${t('info.search_title')}`} />
            </S.IconContainer>
            <S.CardTitle>{t('info.search_title')}</S.CardTitle>
            <S.CardDescription>
              {t('info.search_text')}
            </S.CardDescription>
          </S.GridCard>

        </S.Grid>
      </S.Container>
    </S.Section>
  );
};

export default InfoGrid;
